import { useState } from "react";
import { motion } from "framer-motion";
import { playThresholdSwell } from "../utils/swell";

const EASE = [0.22, 1, 0.36, 1];
const RING_DELAYS = [0, 0.12, 0.24, 0.36, 0.48];

export default function Threshold({ onEnter }) {
  const [entering, setEntering] = useState(false);

  const handleEnter = () => {
    if (entering) return;
    setEntering(true);
    playThresholdSwell();
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    setTimeout(onEnter, reduced ? 200 : 1600);
  };

  return (
    <section id="entry" className={entering ? "entering" : ""} data-testid="threshold-screen">
      <div className="entry-hues" aria-hidden="true" />
      <div className="rings" aria-hidden="true">
        {RING_DELAYS.map((d, i) => (
          <div key={i} className="ring" style={{ width: 80, height: 80, animationDelay: `${d}s` }} />
        ))}
      </div>

      <motion.button
        className="kicker"
        data-testid="threshold-brand-button"
        onClick={handleEnter}
        aria-label="Enter The Hall"
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 0.9, y: 0 }}
        transition={{ duration: 0.9, delay: 0.3, ease: EASE }}
      >
        The WOWOW Gallery
      </motion.button>

      <h1 className="display" data-testid="entry-title">
        <span className="mask-line">
          <motion.span initial={{ y: "112%" }} animate={{ y: 0 }} transition={{ duration: 1.1, delay: 0.45, ease: EASE }}>
            Our
          </motion.span>
        </span>
        <span className="mask-line">
          <motion.span initial={{ y: "112%" }} animate={{ y: 0 }} transition={{ duration: 1.1, delay: 0.6, ease: EASE }}>
            Collection
          </motion.span>
        </span>
      </h1>

      <motion.p
        className="sub"
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.95, ease: EASE }}
      >
        A private world of lenticular works, made in collaboration with artists who think for the future.
      </motion.p>

      <motion.button
        id="enter-btn"
        data-testid="enter-portal-button"
        onClick={handleEnter}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 1.25 }}
      >
        Enter
      </motion.button>
    </section>
  );
}
